import { createSelector, createSlice } from "@reduxjs/toolkit";
import { getPartners,
    addOrRemoveSelectedPartner,
    getPartnerConnections,
    deletePartnerConnection,
    createPartnerConnection,
    updatePartnerConnection,
    resetAllConnectionselectedincspAs0,
} from "../thunks/partnerThunk";
import { toast } from "react-toastify";

const initialState = {
    isLoading: true,
    error: null,
    availablePartners: [],
    isPartnerSelected: 0,
    partnerConnections: [],
    connection: null,
    resetSuccess: 0,
};

const partner = createSlice({
    name: 'partner',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
        .addCase(getPartners.fulfilled, (state,action) => {
            state.availablePartners = getChannelAndPartnersData(action.payload?.partners)
            state.error = null;
            state.isLoading = false;
        })
        .addCase(getPartners.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(getPartners.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(addOrRemoveSelectedPartner.fulfilled, (state,action) => {
            if(action.payload?.status_code === 200){
                state.error = null;
                state.isLoading = false;
                state.isPartnerSelected+= 1;
                toast.success("Selected partner updated successfully")
            }
            else{
                state.isLoading = false;
                toast.error("Please retry!")
            }
            
        })
        .addCase(addOrRemoveSelectedPartner.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(addOrRemoveSelectedPartner.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(getPartnerConnections.fulfilled, (state, action) => {
            state.isLoading = false;
            state.partnerConnections = action.payload?.connections;
        })
        .addCase(getPartnerConnections.pending, (state, action) => {
            state.isLoading = true;
        })
        .addCase(getPartnerConnections.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(deletePartnerConnection.fulfilled, (state, action) => {
            state.isLoading = false;
            if(action.payload?.status_code === 200){
                toast.success(action.payload?.success)
            }
            else{
                toast.error(action.payload?.error)
            }
        })
        .addCase(deletePartnerConnection.pending, (state, action) => {
            state.isLoading = true;
        })
        .addCase(deletePartnerConnection.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            toast.error("Call rejected");
        })
        .addCase(createPartnerConnection.fulfilled, (state, action) => {
            state.isLoading = false;
            if(action.payload?.status_code === 200){
                state.connection = action.payload.connection;
                toast.success(action.payload.success);
            } else {
                toast.error(action.payload.error.name);
            }
        })
        .addCase(createPartnerConnection.pending, (state, action) => {
            state.isLoading = true;
        })
        .addCase(createPartnerConnection.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            toast.error(action.payload.data.error);
        })
        .addCase(updatePartnerConnection.fulfilled, (state, action) => {
            state.isLoading = false;
            if(action.payload?.status_code === 200){
                state.connection = action.payload.connection;
                toast.success(action.payload.success);
            } else {
                toast.error(action.payload.error);
            }
        })
        .addCase(updatePartnerConnection.pending, (state, action) => {
            state.isLoading = true;
        })
        .addCase(updatePartnerConnection.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            toast.error(action.payload.data.error);
        })
        .addCase(resetAllConnectionselectedincspAs0.fulfilled, (state, action) => {
            state.isLoading = false;
            if(action.payload?.status_code === 200){
                state.resetSuccess+= 1; 
                toast.success("connection reset successful!");
            }
            else{
                toast.error(action.payload?.error);
            }
        })
        .addCase(resetAllConnectionselectedincspAs0.pending, (state, action) => {
            state.isLoading = true;
        })
        .addCase(resetAllConnectionselectedincspAs0.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            toast.error("Call rejected");
        })
    }
});

export const selectCampaignConnectionOptions = (partnerId) => createSelector(
    (state) => state.partner,
    (partner) => {
      let partnerConnection = partner.partnerConnections.reduce((acc, connection) => {
        if (connection.partner_id === partnerId) {
          acc.push({ label: connection.name, value: connection.id, connection: connection });
        }
        return acc;
      }, []);
      partnerConnection.unshift({
        label: 'New Connection',
        value: ' ',
        connection: {}
      });
  
      return partnerConnection;
    }
);

const getChannelAndPartnersData = (data) => {
    if (data?.length > 0) {
        return data.map(item => ({
            value: item.id,
            label: item.name,
        }));
    }
    return [];
};


export const { actions } = partner;
export default partner.reducer;
